module.exports = __webpack_public_path__ + "static/media/playIcon.f7e353cc.svg";